import { Badge } from '@ui/base/badge'

import { type Api } from '../api/types'
import { myFulfillmentStatusBadges } from '../lib/labels'

/**
 * Пометка состояния карточки для её владельца. У опубликованной пометки нет: она видна в каталоге,
 * объяснять нечего. Неизвестное значение тоже остаётся без пометки — пустая плашка объясняет
 * меньше, чем её отсутствие.
 */
export const MyFulfillmentStatusBadge = ({ status }: { status: Api.MyFulfillmentStatus }) => {
  const badge = myFulfillmentStatusBadges[status]

  return badge ? <Badge variant={badge.variant}>{badge.label}</Badge> : null
}
